export default __webpack_public_path__ + "static/media/sushi-ebi-tempura.be9bb756.jpg";